import { useTranslation } from 'react-i18next';
import ControlledTextEditor from '../../../../components/custom-inputs/ControlledTextEditor';
import { TimedProjectEditorMenu } from '../../../../components/editor/menu-option-lists/menu-item-lists';

const About = () => {
  const { t } = useTranslation();
  return (
    <ControlledTextEditor
      label={t('pitches.teamDescription')}
      name="overview.description"
      items={TimedProjectEditorMenu}
      required
    />
  );
};

export default About;
